import request from '@/common/request'
export default {
  login: data => {
    return request({
      url: '/login',
      method: 'post',
      data
    })
  },
  loginOut: data => {
    return request({
      url: '/user/distroySession',
      method: 'get',
      data
    })
  },
  refreshCode: () => {
    return request({
      url: '/code/image',
      method: 'post'
    })
  },
  isUserLoggedIn: data => {
    return request({
      url: '/user/isUserLoggedIn',
      method: 'get',
      data
    })
  },
  queryUserInfo: params => {
    return request({
      url: '/user/getCurrentUserInfo',
      method: 'get',
      params
    })
  },
  /**
  *  create 增
  *  delete 删
  *  update 改
  *  query  查
 */
  createUser: (dynaSeg, data, params) => {
    return request({
      url: '/user/array/',
      method: 'post',
      data,
      params
    })
  },
  deleteUser: (dynaSeg, data, params) => {
    return request({
      url: `/user/${dynaSeg.id}`,
      method: 'delete',
      data,
      params
    })
  },
  updateUser: (dynaSeg, data, params) => {
    return request({
      url: `/user/array/${dynaSeg.id}`,
      method: 'put',
      data,
      params
    })
  },
  queryUser: params => {
    return request({
      url: '/user',
      method: 'get',
      params
    })
  },
  queryUserPluginList: (dynaSeg) => {
    return request({
      url: `/user/plugin/${dynaSeg.userId}`,
      method: 'get'
    })
  },
  modifyPwd: params => {
    return request({
      url: '/user/modifyPwd',
      method: 'post',
      params
    })
  },
  resetPsd: params => {
    return request({
      url: '/user/resetPwd',
      method: 'put',
      params
    })
  },
  // 配置常用菜单
  querySettingNav: params => {
    return request({
      url: '/userPermission/getPermisTree',
      method: 'get',
      params
    })
  },
  updateSettingNav: data => {
    return request({
      url: '/userPermission/addPermisByUser',
      method: 'post',
      data
    })
  },
  findUserByOrg: () => {
    return request({
      url: '/user/findUserByOrg',
      method: 'POST'
    })
  },
  findUserByOrgId: (dynaSeg, data, params) => {
    return request({
      url: `/user/findUserByOrgId/${dynaSeg.orgId}`,
      method: 'get',
      params
    })
  },
  findUserList: (params,data) => {
    return request({
      url: `/user/findUserByRoleIds?roleIds=${params}`,
      method: 'post',
      data
    })
  },
  resetPin: (dynaSeg) => {
    return request({
      url: `/user/resetPin?userId=${dynaSeg}`,
      method: 'put',
    })
  } 
}



// WEBPACK FOOTER //
// ./src/api/modules/user.js